module.exports = __webpack_public_path__ + "img/care_main1.fbdc05c0.png";